var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button as MuiButton, buttonClasses } from '@mui/material';
import styled from '@mui/material/styles/styled';
import { alpha } from '@mui/system';
import Loading from '../Loading';
var ButtonRoot = styled(MuiButton)(function (_a) {
    var _b;
    var color = _a.color, theme = _a.theme, variant = _a.variant, size = _a.size;
    return __assign(__assign(__assign(__assign(__assign({ minWidth: 'auto', '& .MuiButton-startIcon': {
            marginRight: '4px'
        }, '&:hover': __assign(__assign({ boxShadow: 'none' }, (variant === 'text' &&
            color !== 'inherit' && {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
        })), (variant === 'contained' &&
            color !== 'inherit' && {
            backgroundColor: alpha(theme.palette[color].main, 0.8),
        })) }, (size === 'small' && {
        padding: '1px 8px',
    })), (color === 'inherit' && {
        borderColor: 'rgba(0,0,0,.12)',
        color: theme.palette.text.primary,
        '&:hover': {
            background: theme.palette.action.hover,
            borderColor: 'rgba(0,0,0,.04)',
        },
    })), (variant === 'text' &&
        color !== 'inherit' && {
        color: theme.palette[color].main,
    })), (variant === 'outlined' && __assign(__assign(__assign({ backgroundColor: '#fff' }, (size === 'small' && {
        padding: '0px 8px',
    })), (size === 'medium' && {
        padding: '4px 16px',
    })), (size === 'large' && {
        padding: '8px 24px',
    })))), (_b = {}, _b["&." + buttonClasses.disabled] = {
        border: '1px solid rgba(0,0,0,.04)'
    }, _b));
});
var Button = function (props) {
    var loading = props.loading, children = props.children, text = props.text, icon = props.icon, buttonProps = __rest(props, ["loading", "children", "text", "icon"]);
    if (loading) {
        buttonProps.disabled = true;
    }
    buttonProps['startIcon'] = buttonProps.startIcon || icon;
    var LoadingRender = function () { return loading ? React.createElement(Loading, { isMask: false, size: 16 }) : null; };
    return (React.createElement(ButtonRoot, __assign({}, buttonProps),
        children || text,
        React.createElement(LoadingRender, null)));
};
Button.defaultProps = {
    variant: 'contained',
    loading: false,
    color: 'primary',
    size: 'medium',
};
export default Button;
